import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommodityType, InvoiceElectricityAndCompanyGet, InvoiceGasAndCompanyGet } from '../../../../core/interfaces/invoice-interfaces';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { InvoiceService } from '../../../../core/api/invoice.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { CommonModule } from '@angular/common';
import { DropDownSectionComponent } from "../../../../shared/components/drop-down-section/drop-down-section.component";
import { Location } from '../../../../core/interfaces/location';
import { EditCancelButtonComponent } from "../../../../shared/components/edit-cancel-button/edit-cancel-button.component";
import { CreateCompanyLocationComponent } from "../create-company-location/create-company-location.component";
import { CustomDropdownComponent } from "../../../../shared/components/custom-dropdown/custom-dropdown.component";
import { NavigationShareService } from '../../../../core/services/navigation-share.service';

@Component({
  selector: 'app-company-information',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, DropDownSectionComponent, EditCancelButtonComponent, CreateCompanyLocationComponent, CustomDropdownComponent],
  templateUrl: './company-information.component.html',
  styleUrl: './company-information.component.css'
})
export class CompanyInformationComponent implements OnInit {
  constructor(private invoiceService: InvoiceService, private apiError: ApiErrorService, private navigationShareService: NavigationShareService) { }

  isOpen: boolean = true;

  @Input() invoice?: InvoiceElectricityAndCompanyGet | InvoiceGasAndCompanyGet;
  @Input() toast?: ToastComponent;
  @Input() commodityType?: CommodityType;
  @Input() listOfLocations: Location[] = [];

  // Successfuly created location
  @Input() successCallbackFunction!: () => void;

  // Dropdown
  locationsDropdownOptions: string[] = [];
  selectedLocationDropdown: number | undefined;

  initialLocationSelected: number | undefined;

  selectedLocation = '';

  // Editing
  isEditing = false;

  // Location dialog
  @ViewChild(CreateCompanyLocationComponent) locationDialog!: CreateCompanyLocationComponent;

  ngOnInit(): void {
    this.populateLocationsDropdown();
  }

  populateLocationsDropdown(): void {
    this.locationsDropdownOptions = [];
    this.initialLocationSelected = undefined;

    this.listOfLocations.forEach((location, index) => {
      const label = `${location.street ?? ''} ${location.number ?? ''}, ${location.postal_code ?? ''} ${location.city ?? ''}`;
      this.locationsDropdownOptions.push(label);

      if (location.id === this.invoice?.location_id) {
        this.selectedLocationDropdown = index;
        this.initialLocationSelected = index;

        // Share location for invoice save
        this.navigationShareService.setState("invoiceReviewLocation", location);
      }
    });
  }

  onClickEdit() {
    this.isEditing = true;
  }

  cancelEditData() {
    this.isEditing = false;

    this.selectedLocationDropdown = this.initialLocationSelected;
  }

  saveEditData() {
    if (this.selectedLocationDropdown !== undefined) {
      this.navigationShareService.setState("invoiceReviewLocation", this.listOfLocations[this.selectedLocationDropdown]);
      this.initialLocationSelected = this.selectedLocationDropdown;
    }
    else {
      this.navigationShareService.setState("invoiceReviewLocation", undefined);
    }

    this.isEditing = false;
  }

  getSelectedLocation() {
    if (this.selectedLocationDropdown === undefined) {
      return undefined;
    }
    return this.listOfLocations[this.selectedLocationDropdown];
  }

  editLocation(editLocation?: Location) {
    this.locationDialog.openModal(editLocation);
  }
}
